import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormControl} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {ContractTypeModel} from '../../../../models/ContractTypeModel';
import {AllSettingsFilterModel} from '../../../../models/AllSettingsFilterModel';
import {RegionModel} from '../../../../models/RegionModel';
import {LocalCustomerModel} from '../../../../models/LocalCustomerModel';
import {ProviderModel} from '../../../../models/ProviderModel';
import {ResourcesUnitModel} from '../../../../models/ResourcesUnitModel';
import { ProjectConstants } from 'src/app/project-constants';
import {DesignServicesModel} from '../../../../models/DesignServicesModel';
import {CurrencyModel} from '../../../../models/CurrencyModel';
import {SizeModel} from '../../../../models/SizeModel';
import {SiteModel} from '../../../../models/SiteModel';
import {ContractTypeService} from '../../../general-services/service-contract-type/contract-type.service';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';

@Component({
  selector: 'app-reference-month-filter',
  templateUrl: './reference-month-filter.component.html',
  styleUrls: ['./reference-month-filter.component.scss']
})
export class ReferenceMonthFilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {
  listMonthFilter: any[];
  annoMese: Date;
  annoMeseFrom: Date;
  optionSelectedFrom: any;

  @Output() numYearMonthFromEventEmitter = new EventEmitter<any>();

  @Input() numAnnoMeseData: any;
  @Input() numAnnoMeseSelected: any;
  @Input() reportSection: boolean;
  @Input() periodMode: boolean = false;
  // SESSION_STORAGE_LABELS: any;

  constructor() {
    super();
  }

  placeholder: any;
  placeholderFrom: any;
  providerSelected: ProviderModel;
  ngOnInit() {
    this.providerSelected = JSON.parse(sessionStorage.getItem(new ProjectConstants().SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;
    switch(this.providerSelected.cod){
      case 'IBM':
        this.placeholder = "Reference Month";
        this.placeholderFrom = "Reference Month From";
        break;
      case 'DXC':
        this.placeholder = "Service Date";
        this.placeholderFrom = "Service Date From";
        break;
      default: { 
        this.placeholder = "Reference Month";
        this.placeholderFrom = "Reference Month From";
        break;
      } 
    }
  }

  ngOnChanges (changes: SimpleChanges) {
    if ('numAnnoMeseData' in changes) {
      this.listMonthFilter = this.numAnnoMeseData;
      // this.optionSelected = this.numAnnoMeseData ? this.numAnnoMeseData[0] : null;
    }
    if (this.numAnnoMeseSelected) {
      this.optionSelected = this.numAnnoMeseSelected;
    }
  }

  public getElementSelectedFrom(): void {
    this.numYearMonthFromEventEmitter.emit(this.optionSelected);
  }

  getAnnoMese(annoMese: number ): string {
    const year = Number(annoMese.toString().substring(0, 4));
    const month = Number(annoMese.toString().substring(4, 6));

    const options = { month: 'long', year: 'numeric' };
    const parsedYearMonth = new Date(year, month - 1);

    return parsedYearMonth.toLocaleDateString('en-US', options);
  }

  reset() {
    this.optionSelected = null;
    this.numAnnoMeseSelected = null;
    this.optionSelectedFrom = null;
  }

  compareObjects(o1: any, o2: any) {
    if (o2 === undefined || o2 ===  null) {
      return false;
    }
    return o1 === o2;
  }


  ngOnDestroy(): void {
  }

}
